export default __webpack_public_path__ + "static/media/4-2_image03@2x.c366f8d8.png";